module.exports = __webpack_public_path__ + "img/conversation_history.710f799c.svg";